import _ from 'lodash';
import * as actions from 'app/actions/support';
import * as commonActions from 'app/common/actions/common';
import * as client from './contentful-client';

export const fetchSupportArticleDetails = slug => ({
  promise: () => client.getSupportArticle(slug),
  events: ['PROMISE_PENDING', actions.SET_SUPPORT_ARTICLE_DETAILS, commonActions.SET_PRELOAD_ERROR],
});

export const fetchReferralPage = () => ({
  promise: () => client.getPage('referral-payment-page-rto'),
  events: ['PROMISE_PENDING', actions.SET_REFERRAL_PAGE, 'PROMISE_ERROR'],
});

export const fetchReferral = referralState => ({
  promise: async http => (http.get(`/storefront/api/referrer?state=${referralState}`).then((response) => {
    if (_.get(response, 'refereeID') === undefined) {
      throw { status: 404 }; // eslint-disable-line
    }
    return response;
  })),
  events: ['PROMISE_PENDING', actions.SET_REFERRAL_INFO, 'PROMISE_ERROR'],
});

export const requestPaymentOAuth = (authCode, referralState) => ({
  promise: async http => (http.post('/storefront/api/requestPayment', { authCode, referralState })),
  events: ['PROMISE_PENDING', actions.PAYMENT_REQUEST_ATTEMPT, 'PROMISE_ERROR'],
});

export const requestPaymentNoAuth = (stripeID, referralState) => ({
  promise: async http => (http.post('/storefront/api/requestPayment', { stripeID, referralState })),
  events: ['PROMISE_PENDING', actions.PAYMENT_REQUEST_ATTEMPT, 'PROMISE_ERROR'],
});

export const requestPaymentPaypal = (paypalEmail, referralState) => ({
  promise: async http => (http.post('/storefront/api/requestPayment', { paypalEmail, referralState })),
  events: ['PROMISE_PENDING', actions.PAYPAL_REQUEST, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/support-api.js